<h2 mat-dialog-title>{{ "inspectionReportEditPropertiesDialog.Properties" | translate }}</h2>

<div class="container" fxLayout="row" fxLayoutAlign="center start">
  <div class="form-container" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
    <!--title-->
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="title-div" fxFlex>
        <mat-form-field fxFlex>
          <mat-label class="top-label">{{ "inspectionReportEditPropertiesDialog.reportNamePlaceholder" | translate }}</mat-label>
          <input matInput maxlength="100" [formControl]="reportTitleForm" required />
          <mat-hint [align]="'end'">{{ reportTitleForm.value?.length || 0 }}/100</mat-hint>
          <mat-error *ngIf="reportTitleForm.hasError('required')">
            {{ "inspectionReportEditPropertiesDialog.MsgReportNameReq" | translate }}
          </mat-error>
          <mat-error *ngIf="reportTitleForm.hasError('maxlength')">
            {{ "inspectionReportEditPropertiesDialog.MsgEnterLength" | translate }}
          </mat-error>
          <mat-error *ngIf="reportTitleForm.hasError('pattern') && !reportTitleForm.hasError('required')">
            {{ "inspectionReportEditPropertiesDialog.MsgEnterValidRptName" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="40px">
      <mat-form-field fxFlex>
        <mat-select
          hideSingleSelectionIndicator
          placeholder="{{ 'inspectionReportEditPropertiesDialog.RptTemplate' | translate }}"
          required
          [formControl]="reportTemplateForm"
          (selectionChange)="loadTemplateId()"
        >
          <mat-select-trigger>
            {{ reportTemplateForm.value?.reportTemplate?.name }}
          </mat-select-trigger>
          <mat-option *ngFor="let template of templatesMaster" [value]="template">
            <span
              class="option-label-overflow"
              [matTooltip]="template.reportTemplate.name"
              matTooltipPosition="above"
              matTooltipClass="tooltip-overflow"
            >
              {{ template.reportTemplate.name }}
            </span>
            <span *ngIf="template.removed">{{ "inspectionReportEditPropertiesDialog.Removed" | translate }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="40px">
      <p class="reportQualityMessage">{{ "inspectionReportEditPropertiesDialog.qualityOfTheFinal" | translate }}</p>
      <mat-form-field class="quality-form" id="final-quality-field">
        <mat-select placeholder="{{ finalReportQualityForm.value }}" [formControl]="finalReportQualityForm">
          <mat-option *ngFor="let quality of reportQualities" [value]="quality.value">
            <span class="option-label-overflow">
              {{ quality.displayLabel | translate }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="40px">
      <p class="reportQualityMessage">{{ "inspectionReportEditPropertiesDialog.qualityOfTheDraft" | translate }}</p>
      <mat-form-field class="quality-form" id="draft-quality-field">
        <mat-select placeholder="{{ draftReportQualityForm.value }}" [formControl]="draftReportQualityForm">
          <mat-option *ngFor="let quality of reportQualities" [value]="quality.value">
            <span class="option-label-overflow">
              {{ quality.displayLabel | translate }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="container" fxLayout="row wrap" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary">{{ "inspectionReportEditPropertiesDialog.Cancel" | translate }}</button>
    <button
      mat-raised-button
      [disabled]="!reportTitleForm.value || reportTitleForm.invalid || reportTemplateForm.invalid"
      (click)="submit()"
      color="primary"
    >
      {{ "inspectionReportEditPropertiesDialog.Save" | translate }}
    </button>
  </mat-dialog-actions>
</div>
